import { useActiveProjectScope } from '@xver/hooks/useActiveProject';
import { useProjectsQuery } from '@xver/hooks/useProjectsQuery';
import { projectOptionLabel } from '@xver/utils/projects';
import { useTranslation } from 'react-i18next';

/**
 * A resource list's "Project" cell. An empty or missing `projectId` (a container in its owner's
 * Default project) resolves to the active project, the only project a list returns.
 */
export default function ProjectName({ projectId }: { projectId?: string }) {
    const { t } = useTranslation('projects');
    const { activeProjectId } = useActiveProjectScope();
    const { data: projects } = useProjectsQuery();
    const project = projects?.find((item) => item.id === (projectId || activeProjectId));

    if (!project) return <span className="text-base text-fg/68">—</span>;
    return (
        <div className="min-w-28 max-w-56 break-words text-base">
            {projectOptionLabel(project, t)}
        </div>
    );
}
